import { theme } from '@frontend/theme';
import { Button, useTooltip } from '@frontend/design-system';
import { useSchedulePulseInsuranceTabContext } from '../../context';

type SwitchViewButtonProps = {
  view: 'add-to-list' | 'analytics';
  tooltipMessage: string;
  trackingId?: string;
};

export const SwitchViewButton = ({ view, trackingId, tooltipMessage }: SwitchViewButtonProps) => {
  const { setShouldRenderInsuranceAnalysis } = useSchedulePulseInsuranceTabContext();
  const { tooltipProps, triggerProps, Tooltip } = useTooltip();

  const onTableIconClick = () => {
    setShouldRenderInsuranceAnalysis?.(view === 'analytics');
  };

  return (
    <>
      <Button
        size='large'
        onClick={onTableIconClick}
        variant='secondary'
        iconName={view}
        trackingId={trackingId}
        css={{ padding: theme.spacing(0, 1), height: 0 }}
        {...triggerProps}
      />
      <Tooltip {...tooltipProps}>{tooltipMessage}</Tooltip>
    </>
  );
};
